
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workflows",
      function () {
        return require("private-next-pages/workflows/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workflows"])
      });
    }
  